import React from "react";

export default function Leaderboard() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <h1 className="text-3xl font-bold">🏆 Leaderboard</h1>
    </div>
  );
}
